import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class KeyBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.whitelistKeyCodes = [
            "Control",
            "Alt",
            "Escape",
            "Meta",
            "F1",
            "F2",
            "F3",
            "F4",
            "F5",
            "F6",
            "F7",
            "F8",
            "F9",
            "F10",
            "F11",
            "F12",
        ];
        this.pressedKeyCodes = [];
        this.id = BehaviorType.key;
        this.keyDownHandler = (event) => this.onKeyDown(event);
        this.keyUpHandler = () => this.onKeyUp();
        this.iframeBehaviorListeners = [
            { type: "keydown", listener: this.keyDownHandler },
            { type: "keyup", listener: this.keyUpHandler },
        ];
    }
    onKeyDown(event) {
        if (this.pressedKeyCodes.includes(event.key) === false) {
            this.pressedKeyCodes.push(event.key);
            const isFirstPressedWhitelist = this.whitelistKeyCodes.includes(this.pressedKeyCodes[0]);
            if (isFirstPressedWhitelist) {
                this.addLog(event, this.id, { pressedKeys: this.pressedKeyCodes });
            }
        }
    }
    onKeyUp() {
        this.pressedKeyCodes = [];
    }
    start() {
        window.addEventListener("keydown", this.keyDownHandler);
        window.addEventListener("keyup", this.keyUpHandler);
        this.plasm.debug(`Behavior ${this.id} started`);
    }
    stop() {
        window.removeEventListener("keydown", this.keyDownHandler);
        window.removeEventListener("keyup", this.keyUpHandler);
        this.plasm.debug(`Behavior ${this.id} stopped`);
    }
}
export default KeyBehavior;
